import { render, staticRenderFns } from "./ForwardIcon.vue?vue&type=template&id=2ce5f06a&"
import script from "./ForwardIcon.vue?vue&type=script&lang=js&"
export * from "./ForwardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports